<template>
    <div>
        <modal-x :show="showEdit" @onclose="showEdit = false" :content-style="{ 'max-width': '800px' }">
            <div style="width:100%;height:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;">
                <div style="text-align:left;">
                    <div class="col-xs-12">
                        <h3>Add for: <span v-if="catSelected !== null"> {{ catSelected.child.name }} </span></h3>
                    </div>
                    <div class="col-xs-12 agx-col-head">Label</div>
                    <div class="col-xs-12 agx-col-msg">
                        <input type="text" v-model="label" class="form-control" />
                    </div>
                </div>
                <br />
                <div class="col-xs-12" style="text-align:right;">
                    <input type="button" value="Create New" class="btn btn-primary" @click="addLabel" />
                </div>
            </div>
        </modal-x>

        <div class="col-xs-12 col-md-6">
            <div v-if="cpdCatEditable"><span class="glyphicon glyphicon-pencil btn btn-default" @click="showCatLabelButtons=!showCatLabelButtons" ></span></div>
            <category :showButtons="showCatLabelButtons" :user-id="userId" :cat-node="catNode" :show-create-node="showCreateNode" @catSelected="onCatChange" cat-type="label" :viewMode="{}"
                :showCheckbox="false" :expandAll="true" @onChanges="onOtherChanges"></category>
        </div>


        <div class="col-xs-12 col-md-6">
            <div v-for="item in dataList">
                <div style="width:100%;" v-if="item.childs.length > 0">
                    <div style="font-weight:bolder;">{{ item.parent.name }}</div>
                    <div>
                        <span v-for="cItem in item.childs" class="btn btn-default" style="margin:1px;">
                            {{ cItem.child.name }}:{{ cItem.label.label }} <span class="btn btn-warning"
                                @click="removeLabel(item.parent, cItem)">X</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import imageList from './imageList.vue';
import category from './category.vue';
import apis from '../api/extApi.js';
import modalX from '../components/base/ModalX1.vue';

export default {
    components: {
        modalX: modalX,
        category: category,
        imageList: imageList,
        modalX: modalX
    },
    props: {
        "userId": { type: String, default: null },
        "postId": { type: String, default: null }
    },
    computed:{
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        },
        cpdCatEditable:function(){
            return this.dashProfile && ( !this.dashProfile.hasTeam || this.dashProfile.isAdmin);
        }
    },
    data: function () {
        return {
            showEdit: false,
            catSelected: null,
            label: null,
            catCodes: apis.api.settings.catCodes,
            apiClient: apis.api,
            catNode: null,
            showCreateNode:false,
            catConfigs: [],
            dataList: [],
            allowMultiple: true,
            showCatLabelButtons:false
        };
    },
    methods: {
        onOtherChanges(){
            this.loadCategory();
        },
        addLabel() {
            if (this.label === null || this.label === "") return;
            var newLabel = { postId: this.postId, catId: this.catSelected.child.catId, label: this.label, userId: this.userId };
            this.apiClient.addPostCatLabelPrms(newLabel).done((ret) => {
                console.log('addPostCatLabelPrms', ret);
                this.showEdit = false;
                this.loadCategory();
                if(ret.ok===false){
                    this.$emit('onError',ret);
                }
            });
        },
        onCatChange(ret) {
            this.catSelected = ret;
            console.log('onCatChange', ret);
            this.showEdit = true;
        },
        loadCategory() {
            this.apiClient.getCategoryNodePrms(this.catCodes.label, this.userId).done((catNode) => {
                console.log('categoryLabels catNode is', catNode);
                this.catNode = catNode;
                this.showCreateNode = catNode === null;
            });
            this.dataList = [];
            this.apiClient.getPostCatLabelsPrms(this.postId).done((catConfigs) => {
                console.log("catConfigs", catConfigs);
                this.catConfigs = catConfigs;
                catConfigs.forEach((conf) => {
                    //this.add(conf.parent,conf.child);
                    this.add(conf.parent, conf);
                });
            });
        },
        add(prop, propVal) {
            if (!this.allowMultiple && this.checkExist(prop, propVal, this.dataList)) return;
            var _currentPropRef = this.setParentProp(prop, this.dataList);
            _currentPropRef.childs.push(propVal);
        },
        removeLabel(propObj, propVal) {
            this.apiClient.removePostCatLabelPrms(propVal.label).done((ret) => {
                if (ret === true) {
                    var matched = this.getMatchedPropInternal(propObj, this.dataList);
                    if (matched) {
                        var index = matched.childs.indexOf(propVal);
                        matched.childs.splice(index, 1);
                    }
                }
            });
        },
        checkExist(propObj, valObj, list) {
            var prop = this.getMatchedPropInternal(propObj, list);
            if (!prop) return false;
            var propVal = this.getMatched(valObj, prop.childs, this.propValComparer);
            if (propVal) return true;
            return false;
        },
        getMatched(target, list, comparer) {
            var matched = null;
            list.forEach((item) => {
                if (comparer) {
                    var ret = comparer(target, item);
                    if (ret === true) {
                        matched = item;
                        return;
                    }
                }
            });
            return matched;
        },
        setParentProp(propObj, list) {
            var matched = this.getMatchedPropInternal(propObj, list);
            if (matched) return matched;
            var datum = { parent: propObj, childs: [] };
            //this.dataList.push(datum);
            list.push(datum);
            return datum;
        },
        getMatchedPropInternal(propObj, propArr) {
            var matched = null;
            propArr.forEach((item) => {
                var _propComparer = this.propComparer;
                if (_propComparer) {
                    var ret = _propComparer(propObj, item.parent);
                    if (ret === true) {
                        matched = item;
                        return;
                    }
                }
            });
            return matched;
        },
        propComparer(item0, item1) {
            return item0.catId === item1.catId;
        },
        propValComparer(item0, item1) {
            return item0.child.catId === item1.child.catId;
        }
    },
    created: function () {

    },
    mounted: function () {
        this.loadCategory();
    },
    destroyed: function () {

    }
}
</script>